/**
 * Deduplicate brand IDs, preserving first-seen order.
 * Non-string and blank entries are dropped.
 */
export function normalizeBrandIds(brandIds) {
  if (!Array.isArray(brandIds)) return [];
  const seen = new Set();
  const result = [];
  for (const entry of brandIds) {
    if (typeof entry !== 'string') continue;
    const id = entry.trim();
    if (!id || seen.has(id)) continue;
    seen.add(id);
    result.push(id);
  }
  return result;
}
